import BaseHttp from '@/api/httpHelper';
import baseGwClient from '@/api/base.gateway';

class BaseService extends BaseHttp {
  async uploadToCDN(body: FormData) {
    const { data, error } = await this.post<boolean>(
      '/cdn/upload',
      body,
      { requestKey: 'uploadToCdn', headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return { data, error };
  }
}

export default new BaseService(baseGwClient, '/api');
